<template>
  <v-row class="flex-column mt-6 pr-8">
    <router-view :key="$route.fullPath" />
    <v-col v-if="$route.name === 'Departments'">
      <v-row no-gutters>
        <v-col md="2"
          ><h2 class="title-1 ml-5 primary-text">Departments</h2></v-col
        >
        <v-col class="text-right">
          <v-btn icon @click="resetAll" class="mr-1">
            <v-icon>restart_alt</v-icon>
          </v-btn>
          <v-text-field
            v-model="search"
            class="custom-search"
            label="Search"
            solo
            append-icon="search"
            hide-details
            single-line
            @keyup="getDepartmentsList(), pageReset()"
          />
          <v-btn
            class="primary_btn small"
            depressed
            @click="addDepartmentVisibility = true"
            >Add Department</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="$route.name === 'Departments'" class="custom-panel">
      <v-data-table
        id="departments"
        :headers="headers"
        :items="departments.data"
        :options.sync="options"
        :server-items-length="departments.total"
        :loading="loading"
        hide-default-footer
        :sort-desc.sync="sortDesc"
        :header-props="{ sortIcon: 'arrow_upward' }"
        @update:sort-desc="getDepartmentsList"
        class="elevation-1"
      >
        <template v-slot:item.name="{ item }">
          <b>
            {{ item.name }}
          </b>
        </template>
        <template v-slot:item.action="{ item }">
          <v-row>
            <v-col cols="6">
              <v-btn icon>
                <v-icon @click="getDepartmentById(item.id)">edit</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
      <div class="primary-icon">
        <license-pagination
          :total="departments.total"
          :value="page"
          @input="pageEmit"
        />
      </div>
    </v-col>
    <v-dialog v-model="addDepartmentVisibility" persistent max-width="800px">
      <v-card class="custom-dialog">
        <v-container>
          <v-card-title>
            <span class="text-h5 text-uppercase font-weight-bold"
              >Add Department</span
            >
            <v-spacer></v-spacer>
            <v-btn
              icon
              color="black"
              @click="
                (addDepartmentVisibility = false), (departmentName = null)
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-form v-model="valid" class="form-right-view-lable">
            <v-col class="custom-form mt-5">
              <v-row no-gutters>
                <v-col sm="8">
                  <v-text-field
                    v-model.trim="departmentName"
                    :rules="nameRules"
                    filled
                    label="Department Name"
                    @input="text = ''"
                  />
                  <font color="red" class="v-virtual-table">{{ text }}</font>
                </v-col>
              </v-row>
            </v-col>
          </v-form>
          <v-container>
            <v-divider />
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn
              class="secondary-btn"
              text
              @click="
                (addDepartmentVisibility = false), (departmentName = null)
              "
            >
              Cancel
            </v-btn>
            <v-btn
              :disabled="!valid || buttonCheck() || isDuplicate"
              class="primary_btn small"
              depressed
              @click="addDepartment"
              >Create</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDepartmentVisibility" persistent max-width="800px">
      <v-card class="custom-dialog">
        <v-container>
          <v-card-title>
            <span class="text-h5 text-uppercase font-weight-bold"
              >Edit Department</span
            >
            <v-spacer></v-spacer>
            <v-btn
              icon
              color="black"
              @click="
                (editDepartmentVisibility = false), (departmentName = null)
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-form v-model="valid" class="form-right-view-lable">
            <v-col class="custom-form mt-5">
              <v-row no-gutters>
                <v-col sm="8">
                  <v-text-field
                    v-model.trim="departmentName"
                    :rules="nameRules"
                    filled
                    label="Department Name"
                    @input="text = ''"
                  />
                  <font color="red" class="v-virtual-table">{{ text }}</font>
                </v-col>
              </v-row>
            </v-col>
          </v-form>
          <v-container>
            <v-divider />
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn
              class="secondary-btn"
              text
              @click="
                (editDepartmentVisibility = false), (departmentName = null)
              "
            >
              Cancel
            </v-btn>
            <v-btn
              :disabled="!valid || buttonCheck() || isDuplicate"
              class="primary_btn small"
              depressed
              @click="updateDepartmentById"
              >Save</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { storeActions } from '@/store/actions.constants';
import licensePagination from '@/components/LicensePagination/licensePagination.vue';
export default {
  components: { licensePagination },
  data: () => ({
    headers: [
      {
        text: 'Departments',
        align: 'start',
        value: 'name',
      },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    search: '',
    loading: false,
    page: 1,
    itemsPerPage: 10,
    sortDesc: [],
    options: {},
    valid: false,
    departmentName: null,
    isDuplicate: false,
    text: '',
    departmentObj: {},
    nameRules: [
      (v) => !!v || 'Department is Required',
      (v) =>
        (v.length > 0 && /^[^\s]/.test(v)) ||
        'Initial character should not be a space',
      (v) =>
        !!(v && v.toString().split('  ').length <= 1) ||
        'Only one space is allowed in between 2 words',
      (v) =>
        !!(v.trim().length > 2 && v.trim().length < 21) ||
        'String length should be between 3 to 20',
      (v) => /^([^0-9]*)$/.test(v) || 'Numbers not allowed',
    ],
    addDepartmentVisibility: false,
    editDepartmentVisibility: false,
  }),
  computed: {
    ...mapGetters({
      departments: 'departments/getDepartments',
    }),
  },
  async mounted() {
    if (this.options.page !== undefined) await this.getDepartmentsList();
  },
  methods: {
    ...mapActions({
      getDepartments: 'departments/getDepartment',
      createdepartment: 'departments/createDepartment',
      updateDepartment: 'departments/updateDepartmentById',
      getDepartment: 'departments/getDepartmentById',
    }),
    pageReset() {
      if (this.search) {
        this.page = 1;
      }
    },
    pageEmit(data) {
      if (data > 0) this.page = data;
      this.getDepartmentsList();
    },
    resetAll() {
      this.search = '';
      this.page = 1;
      this.sortDesc = [];
      this.options.sortBy.length = 0;
      this.getDepartmentsList();
    },
    getDepartmentsList() {
      this.loading = true;
      const { sortBy } = this.options;
      this.getDepartments({
        page: this.page,
        limit: 10,
        search: this.search || '',
        sort: sortBy[0],
        desc: this.sortDesc[0] || 0,
      })
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data);
            let items = res.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
        });
    },
    async addDepartment() {
      this.departmentObj = await this.createdepartment({
        name: this.departmentName.trim(),
      });
      if (this.departmentObj.status === 200) {
        this.departmentName.trim();
        this.addDepartmentVisibility = false;
        this.getDepartmentsList();
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: 'Department Created Successfully',
          timeout: 1000,
          color: 'success',
        });
        this.departmentName = null;
      } else {
        this.text = '';
        this.text = this.departmentObj.data.message;
      }
    },
    buttonCheck() {
      // var check = (val) => val.check === false;
      if (this.departmentName == null) {
        return true;
      } else {
        return false;
      }
    },
    getDepartmentById(id) {
      let departmentObj = {
        id: id,
      };
      this.editDepartmentVisibility = true;
      this.getDepartment(departmentObj)
        .then((res) => {
          console.log(res);
          this.departmentName = res.data.name;
          this.editId = res.data.id;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          // Skip login until API and schema got finalise
          this.text = err.message;
          console.error(err);
        });
    },
    updateDepartmentById() {
      const departmentObj = {
        id: this.editId,
        name: this.departmentName.trim(),
      };
      this.updateDepartment(departmentObj).then((res) => {
        if (res.status === 200) {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: res.data.message,
            timeout: 1000,
            color: 'success',
          });
          this.editDepartmentVisibility = false;
          this.getDepartmentsList();
          this.departmentName = null;
        } else {
          this.text = '';
          this.text = res.data.message;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
